<span class="truncate-lines-cell-renderer" [style]="{ '-webkit-line-clamp': lines }">{{
    formattedValue
}}</span>
